import { Component, Input } from '@angular/core';

export interface Regle {
  description: string;
  valid: boolean;
}

@Component({
    selector: 'di-information-popover',
    templateUrl: './information-popover.component.html',
    styleUrls: ['./information-popover.component.scss'],
})
export class InformationPopoverComponent{

    @Input() regles: Regle[] = [
      {description: "description de la majoration", valid: true},
      {description: "description de la majoration bien plus longue que les autres ! ", valid: true},
      {description: "description de la majoration", valid: false},
      {description: "description de la majoration", valid: true}
    ];

    constructor() {}

}
